<template lang="pug">
  .content
    .md-layout
      .md-layout-item.md-medium-size-100.md-size-50
        user-card(
          :firstName="user.first_name"
          :lastName="user.last_name"
          :major="user.major"
          :grad_year="user.grad_year"
          :role="user.teaching_role"
          :eid="user.eid"
          :isPaid="isPaid"

        )
      .md-layout-item.md-medium-size-100.md-size-50
        edit-profile-form
      .md-layout-item.md-medium-size-100.md-size-50
        go-pro(:isPaid="isPaid")
      .md-layout-item.md-medium-size-100.md-size-50
          form
            md-card
              md-card-header(data-background-color="green")
                h4(class="title") Password Reset
                p(class="category") Enter your current password to receive reset email
              md-card-content
                .md-layout
                  .text-center.md-layout-item
                    h6(v-if="success") You should receive an email with a link to reset your password!
                    h6(v-if="resetError" style="color: red") Sorry, there was an error sending your password reset email.
                    md-button.md-raised.md-success(@click="sendPasswordReset") 
                      | Send Reset Email
</template>

<script>
import EditProfileForm from "@/pages/UserManagement/EditProfileForm.vue";
import UserCard from "@/pages/UserManagement/UserCard.vue";
import GoPro from "@/pages/UserManagement/GoPro.vue";
import axios from 'axios';

export default {
  components: {
    EditProfileForm,
    UserCard,
    GoPro,
  },
  created() {
    this.getUserData();
  },
  data() {
    return {
      user: null,
      isPaid: null,
      password: null,
      resetError:null,
      success: null,
    };
  },
  methods: {
    getUserData() {
      this.user = this.$store.state.user;
      this.isPaid = this.$store.state.isPaid;
    },
    sendPasswordReset() {
      this.resetError = null;
      this.success = null;
      
      axios.post('/api/sendpasswordreset', {})
      .then((response) => {
        this.success = true;
      }).catch((error) => {
        this.resetError = true;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/UserProfile.vue